
const getLocalVaultList = async (mvcmydashboard) => {
	var list = [];

	let sessionuuid = await mvcmydashboard.getCurrentSession();
	let vaults = await mvcmydashboard.getLocalVaultList(sessionuuid).catch(err => {});

	for (var i = 0; i < (vaults ? vaults.length : 0); i++) {
		let vault = vaults[i];
		let record = {id: vault.name, uuid: vault.name};
		
		record = Object.assign(record, vault);

		list.push(record);
	}

	return list;
};


export default {
	getFullList: async (mvcmydashboard) => {
		let list = [];

		if (!mvcmydashboard) return list;

		list = await getLocalVaultList(mvcmydashboard);

		return list;
	},

	getMany: async (mvcmydashboard, params) => {
		throw new Error('getMany not implemented');
	},

	getManyReference: async (mvcmydashboard, params) => {
		throw new Error('getManyReference not implemented');
	},

	update: async (mvcmydashboard, params) => {
		throw new Error('update not implemented');
	},

	updateMany: async (mvcmydashboard, params) => {
		throw new Error('updateMany not implemented');
	},

	create: async (mvcmydashboard, params) => {
		throw new Error('create not implemented');
	},

	delete: async (mvcmydashboard, params) => {
		throw new Error('delete not implemented');
	},

	deleteMany: async (mvcmydashboard, params) => {
		throw new Error('deleteMany not implemented');
	},

};